import { VpnPriceComparisonWrapper } from "@components/layouts";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";
import { getPageProps } from "@services/initial-calls";
import { GetServerSideProps } from "next";
import React, { ReactElement } from "react";
import style from "@components/vpnpricecomparison/legal/legal.module.scss";

export default function PrivacyPolicyPage(): ReactElement {
    return (
        <VpnPriceComparisonWrapper>
            <PrivacyPolicy mainWrapperClassName={style["legal"]} />
        </VpnPriceComparisonWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Privacy Policy",
    });
};
